export default __webpack_public_path__ + "static/media/loading.a8de09f7.svg";